<template>
  <div v-if="funds.length > 0" class="form-item">
    <div v-if="dialogVisible" class="fund-list">
      <div class="fund-list-title">
        <span>{{ name }}的管理基金</span> <span v-if="subtitle">（{{ subtitle }}）</span>
        <i class="fund-close el-icon el-icon-close" @click="dialogVisible = false"></i>
        <div>
          <el-tag v-if="duration" type="success" size="mini" style="margin-right: 5px;">任职期: {{ duration }}</el-tag>
          <el-tag v-if="scale" type="danger" size="mini" style="margin-right: 5px;">规模: {{ scale }}</el-tag>
        </div>
      </div>
      <div class="fund-list-body"><fundList :rid="rid" :funds="funds" /></div>
    </div>
    <el-button size="mini" type="primary" plain @click="dialogVisible = true">管理基金</el-button>
  </div>
</template>
<script>
import FundChart from './fund-chart'
import FundList from './fund-list'

export default {
  components: { FundChart, FundList },
  props: {
    rid: { type: String, default: '' },
    name: { type: String, default: '' },
    subtitle: { type: String, default: '' },
    mainFunds: { type: Array, default: () => [] },
    scale: { type: String, defalut: '' },
    duration: { type: String, defalut: '' },
  },
  data() {
    return {
      dialogVisible: false,
      funds: [],
    }
  },
  async created() {
    const res = await app.service('radish').getFundsByRid({ rid: this.rid })
    if (res.status === 'success') {
      const funds = res.data.map(f => {
        const manager = f.manager || (f.managers && f.managers.find(m => m.id == this.rid))
        f.mStartDate = manager && manager.startDate ? manager.startDate : ''
        if (this.mainFunds.includes(f._qutkeId)) {
          f.isMain = true
        }
        return f
      })
      funds.sort((a, b) => (a.mStartDate < b.mStartDate ? 1 : -1))
      this.funds = funds
    }
  },
}
</script>
<style>
.fund-list {
  position: fixed;
  top: 20%;
  left: 40%;
  right: 10%;
  padding: 10px;
  background: #fff;
  border-radius: 2px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);
  z-index: 1005;
}
.fund-list-title {
  position: relative;
  padding: 10px;
  line-height: 24px;
  font-size: 18px;
  color: #303133;
}
.fund-close {
  position: absolute;
  top: 10px;
  right: 10px;
  cursor: pointer;
}
.fund-list-body {
  max-height: 50vh;
  overflow: auto;
}
</style>
